module.exports = __webpack_public_path__ + "media/fonts/SFProText-Light-bfe3639dbcea45b47f0b9a395eb9c9c1.woff2";